import { Link } from 'react-router-dom';
import { CONTACT, CONTACT_PATHS } from '../content/data';
import { useContent } from '../lib/content';

const COLUMNS = [
  {
    title: 'Students',
    links: [
      { label: 'Programmes', to: '/programmes' },
      { label: '18-Month Programme', to: '/programmes/flagship' },
      { label: 'Technical Track', to: '/programmes/technical' },
      { label: 'Business & Creator Track', to: '/programmes/business-creator' },
      { label: 'Scholarship', to: '/scholarship' },
      { label: 'Alumni', to: '/students#alumni' },
      { label: 'FAQs', to: '/students#faq' },
    ],
  },
  {
    title: 'Enterprises',
    links: [
      { label: 'CSR Routing', to: '/enterprises/csr' },
      { label: 'Talent Acquisition', to: '/enterprises/talent' },
      { label: 'Enterprise Services', to: '/enterprises#services' },
      { label: 'Marketing Cell', to: '/enterprises/marketing-cell' },
      { label: 'Membership', to: '/enterprises/membership' },
      { label: 'Research', to: '/enterprises/research' },
      { label: 'FAQs', to: '/enterprises#faq' },
    ],
  },
  {
    title: 'Explore',
    links: [
      { label: 'About', to: '/about' },
      { label: 'Institutions', to: '/institutions' },
      { label: 'Press & Insights', to: '/press' },
      { label: 'Contact', to: '/contact' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy Policy', to: '/legal/privacy' },
      { label: 'Terms & Conditions', to: '/legal/terms' },
      { label: 'Cookie Policy', to: '/legal/cookies' },
      { label: 'Digital Ethics / Responsible AI', to: '/legal/ethics' },
    ],
  },
];

export default function Footer() {
  const { settings, links } = useContent();
  const footerLinks = links.filter((l) => l.location === 'footer');
  const email = settings.contactEmail || CONTACT.email;
  const phone = settings.contactPhone || CONTACT.phone;
  const phoneHref = `tel:+91${phone.replace(/\D/g, '')}`;
  const columns = footerLinks.length
    ? [...COLUMNS.slice(0, 3), { title: 'More', links: footerLinks.map((l) => ({ label: l.label, to: l.url })) }, COLUMNS[3]]
    : COLUMNS;
  return (
    <footer data-testid="global-footer" className="bg-navy pb-24 pt-16 text-white sm:pt-24 md:pb-10">
      <div className="wrap">
        <div className="grid gap-12 lg:grid-cols-[1.2fr_2fr]">
          <div>
            <img src="/assets/logolight.webp" alt="DITEC" className="h-20 w-auto sm:h-24" />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/60">
              Digital Intelligence & Technology Excellence Council
            </p>
            <p className="mt-6 font-serif text-lg italic text-gold">
              {settings.footerStatement || 'Building capability for a more connected digital economy.'}
            </p>
            <div className="mt-8 space-y-2">
              <a data-testid="footer-email" href={`mailto:${email}`} className="block text-sm font-semibold text-white transition-colors hover:text-gold">
                {email}
              </a>
              <a data-testid="footer-phone" href={phoneHref} className="block font-mono text-sm text-white/70 transition-colors hover:text-gold">
                +91 {phone}
              </a>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-8 sm:grid-cols-4">
            {columns.map((col) => (
              <div key={col.title}>
                <h4 className="overline !text-[10px] text-gold/70">{col.title}</h4>
                <ul className="mt-4 space-y-2.5">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      <Link
                        data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, '-')}`}
                        to={l.to}
                        className="text-[13px] text-white/65 transition-colors hover:text-gold"
                      >
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 rounded-3xl border border-white/10 bg-navy-800/60 p-6 sm:p-8">
          <span className="overline !text-base font-semibold text-[#00BFFF] sm:!text-lg">Start a conversation as</span>
          <div className="mt-4 flex flex-wrap gap-2">
            {CONTACT_PATHS.map((p) => (
              <Link
                key={p.role}
                data-testid={`footer-role-${p.role}`}
                to={`/contact?role=${p.role}`}
                className="touch-target rounded-full border border-white/15 px-5 py-2.5 text-xs font-semibold text-white/80 transition-colors hover:border-gold hover:text-gold"
              >
                {p.title}
              </Link>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-white/40">© {new Date().getFullYear()} DITEC — Digital Intelligence & Technology Excellence Council</p>
          <Link data-testid="footer-admin-link" to="/admin" className="font-mono text-[11px] text-white/30 transition-colors hover:text-gold">
            Admin Console
          </Link>
        </div>
      </div>
    </footer>
  );
}
